import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, withRouter } from "react-router-dom";

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';

import { setUserSession } from "../../Actions/userSessionActions";
import { Trans } from 'react-i18next';
class Invite extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_page: true,
        };
    }

    componentDidMount() {
        document.title = "Invitation - FleetXPress"

        var self = this;
        axios.get('/ajax/invite/' + this.props.match.params.invite_id)
        .then((response) => {
            
            if(response?.data.redirect != undefined) {
                self.props.history.push(('/' + response?.data.redirect));
            }

            self.setState({
                loading_page: true,
            })
        })
        .catch(function(error) {
            //handle error
            if(error.response?.status == 401){
                self.props.history.push('/');
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                self.props.history.push('/');
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        })
    }

    render() {
        if (this.props.userSession.logged_in) {
            if (this.props.settings.pre_redirect_url !== "") {
                return (
                    <Redirect to={{pathname: this.props.settings.pre_redirect_url}} />
                )
            } else {
                return (
                    <Redirect to={{pathname: "/home"}} />
                );
            }
        } else {
            return (
                <LoadingIcon />
            );
        }
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession,
    settings: store.settings
})

export default withRouter(connect(mapStateToProps)(Invite));